import { IDataCommand } from '@aesop-fables/scrinium';
import { inject } from '@aesop-fables/containr';
import type { AxiosResponse } from 'axios';
import { ApiKeys } from '../../../api/apis/ApiKeys';
import { RevShareApi } from '../../../api/apis/RevShareApi';

interface DateRange {
  startDate: string;
  endDate: string;
}

export class GenerateTeamRevShareCsv implements IDataCommand<DateRange, AxiosResponse> {
  constructor(@inject(ApiKeys.RevShare) private readonly api: RevShareApi) {}

  async execute({ startDate, endDate }: DateRange): Promise<AxiosResponse> {
    return await this.api.generateTeamRevShareCsv(startDate, endDate);
  }
}

export class GenerateTeamChargesCsv implements IDataCommand<DateRange, AxiosResponse> {
  constructor(@inject(ApiKeys.RevShare) private readonly api: RevShareApi) {}

  async execute({ startDate, endDate }: DateRange): Promise<AxiosResponse> {
    return await this.api.generateTeamChargesCsv(startDate, endDate);
  }
}

export class GenerateOrgRevShareCsv implements IDataCommand<DateRange, AxiosResponse> {
  constructor(@inject(ApiKeys.RevShare) private readonly api: RevShareApi) {}

  async execute({ startDate, endDate }: DateRange): Promise<AxiosResponse> {
    return await this.api.generateOrgRevShareCsv(startDate, endDate);
  }
}

export class GenerateOrgChargesCsv implements IDataCommand<DateRange, AxiosResponse> {
  constructor(@inject(ApiKeys.RevShare) private readonly api: RevShareApi) {}

  async execute({ startDate, endDate }: DateRange): Promise<AxiosResponse> {
    return await this.api.generateOrgChargesCsv(startDate, endDate);
  }
}

export class GenerateGroupRevShareCsv implements IDataCommand<DateRange, AxiosResponse> {
  constructor(@inject(ApiKeys.RevShare) private readonly api: RevShareApi) {}

  async execute({ startDate, endDate }: DateRange): Promise<AxiosResponse> {
    return await this.api.generateGroupRevShareCsv(startDate, endDate);
  }
}

export class GenerateGroupChargesCsv implements IDataCommand<DateRange, AxiosResponse> {
  constructor(@inject(ApiKeys.RevShare) private readonly api: RevShareApi) {}

  async execute({ startDate, endDate }: DateRange): Promise<AxiosResponse> {
    return await this.api.generateGroupChargesCsv(startDate, endDate);
  }
}

export class GenerateTeamRevSharePdf implements IDataCommand<DateRange, AxiosResponse> {
  constructor(@inject(ApiKeys.RevShare) private readonly api: RevShareApi) {}

  async execute({ startDate, endDate }: DateRange): Promise<AxiosResponse> {
    return await this.api.generateTeamRevSharePdf(startDate, endDate);
  }
}

export class GenerateOrgRevSharePdf implements IDataCommand<DateRange, AxiosResponse> {
  constructor(@inject(ApiKeys.RevShare) private readonly api: RevShareApi) {}

  async execute({ startDate, endDate }: DateRange): Promise<AxiosResponse> {
    return await this.api.generateOrgRevSharePdf(startDate, endDate);
  }
}

export class GenerateGroupRevSharePdf implements IDataCommand<DateRange, AxiosResponse> {
  constructor(@inject(ApiKeys.RevShare) private readonly api: RevShareApi) {}

  async execute({ startDate, endDate }: DateRange): Promise<AxiosResponse> {
    return await this.api.generateGroupRevSharePdf(startDate, endDate);
  }
}
